// = Libs =
import { ChangeEvent, FC, useEffect, useState } from 'react';
import clsx from 'clsx';

// = Styles =
import classes from './checkbox.module.scss';

// = Types =
import { CheckboxProps } from './checkbox.types';

// = Components =
import Icon from '@/common/components/ui/icon/icon';

const Checkbox: FC<CheckboxProps> = (props) => {
  const {
    className = '',
    text = '',
    name = '',
    size = 'normal',
    value = false,
    onChange,
    onChangeEvent,
    onBlur,
  } = props;

  const [isChecked, setIsChecked] = useState<boolean>(value);

  useEffect(() => {
    setIsChecked(value);
  }, [value]);

  const handleChange = (e: ChangeEvent): void => {
    onChangeEvent && onChangeEvent(e);
    onChange && onChange(!isChecked);
    setIsChecked(!isChecked);
  };

  return (
    <label className={clsx({ [classes.checkbox]: true }, className)}>
      <input
        name={name}
        type="checkbox"
        className={classes.checkbox__field}
        value={String(isChecked)}
        checked={isChecked}
        onChange={handleChange}
        onBlur={onBlur}
      />

      <span
        className={clsx({
          [classes['checkbox__fake']]: true,
          [classes['checkbox__fake--active']]: isChecked,
          [classes[`checkbox__fake--${size}`]]: true,
        })}>
        <Icon type="accept" className={classes.checkbox__icon} />
      </span>

      {text && <span className={classes.checkbox__text}>{text}</span>}
    </label>
  );
};

export default Checkbox;
